import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = 'Square Side Length Calculator - Calculate Square Side Length Based on Area or Perimeter';
const DESCRIPTION = 'Square Side Length Calculator calculates the side length of a square based on the entered area or perimeter.';
const KEYWORDS = 'Square Side Length, Calculate Square Side Length, Square Side Length Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/square-side-length';
function Calculator() {
    const [perimeter, setPerimeter] = useState('');
    const [area, setArea] = useState('');
    const [sideLength, setSideLength] = useState('');
    const [calculationType, setCalculationType] = useState('perimeter');
    const [error, setError] = useState('');
    const handleCalculationTypeChange = (newCalculationType) => {
        setCalculationType(newCalculationType);
        if (newCalculationType === 'perimeter') {
            setArea('');
        }
        if (newCalculationType === 'area') {
            setPerimeter('');
        }
    }
    const handleCalculate = () => {
        if ((!perimeter && !area) || (perimeter && area)) {
            setError('Please enter either the area or perimeter only');
            setSideLength('');
            return;
        }
        if (calculationType === 'perimeter') {
            if (perimeter) {
                const perimeterValue = parseFloat(perimeter);
                if (isNaN(perimeterValue) || perimeterValue <= 0) {
                    setError('Please enter a valid and positive value for the perimeter');
                    setSideLength('');
                    return;
                }
                const length = perimeterValue / 4;
                setSideLength(length.toFixed(2));
                setError('');
            }
        } else if (calculationType === 'area') {
            if (area) {
                const areaValue = parseFloat(area);
                if (isNaN(areaValue) || areaValue <= 0) {
                    setError('Please enter a valid and positive value for the area');
                    setSideLength('');
                    return;
                }
                const length = Math.sqrt(areaValue);
                setSideLength(length.toFixed(2));
                setError('');
            }
        }
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>How to Calculate Square Side Length</h2>
                                <p>
                                    Square side length can be calculated based on the area or perimeter using the following rules:
                                </p>
                                <p>
                                    If you have the perimeter:
                                    Side Length = Perimeter / 4
                                </p>
                                <p>
                                    If you have the area:
                                    Side Length = Square Root of the Area
                                </p>
                                <p>
                                    Please enter either the area or perimeter only to calculate the square side length.
                                </p>
                                <hr />
                            </div>
                        </div>
                         <MobileUnderCalAds/>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="ltr">
                                    <div>
                                        Do you want to calculate the side length based on the area or perimeter?
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="calculationType"
                                                id="perimeterRadio"
                                                value="perimeter"
                                                checked={calculationType === 'perimeter'}
                                                onChange={() => handleCalculationTypeChange('perimeter')}
                                            />
                                            <label className="form-check-label" htmlFor="perimeterRadio">
                                                Perimeter
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="calculationType"
                                                id="areaRadio"
                                                value="area"
                                                checked={calculationType === 'area'}
                                                onChange={() => handleCalculationTypeChange('area')}
                                            />
                                            <label className="form-check-label" htmlFor="areaRadio">
                                                Area
                                            </label>
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Perimeter (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Perimeter"
                                                value={perimeter}
                                                onChange={(e) => setPerimeter(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                                disabled={calculationType === 'area'}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Area (cm²)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Area"
                                                value={area}
                                                onChange={(e) => setArea(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                                disabled={calculationType === 'perimeter'}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Calculate Square Side Length
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {sideLength !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        Square Side Length: {sideLength} cm
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
